// Real content extracted from original Shankar Multimedia website
// This contains the actual information from the original website

export const COMPANY_INFO = {
  name: 'Shankar Multimedia',
  tagline: 'oin Shankar Multimedia, leading and top rated animation institute in Mumbai for graphic design, UI/UX, motion graphic design, video editing, vfx, 3D animation, digital marketing and multimedia animation courses with 100% job assistance and placements. Expert hands-on training in Goregaon, Malad, Santacruz, Mulund, Nalasopara and Ghatkopar. Enroll now!',
  founded: 'Early 1990s',
  experience: '36+ years',
  certification: 'ISO 9001:2015-certified',
  founder: {
    name: 'Dharmendra Kumar Singh',
    title: 'Founder / Chairman / Managing Director',
    description: 'Dharmendra Singh, the Founder, Chairman, and Managing Director of Shankar Multimedia and its subsidiaries, is a visionary leader committed to revolutionizing the multimedia industry. With extensive expertise in multimedia animation, he strives to empower aspiring students by providing them with the skills and education needed to excel in their careers. His mission extends beyond education, aiming to uplift underprivileged communities by improving their economic status through accessible learning opportunities. Known for his professional approach and strategic vision, he guides students and team members with clarity and purpose, paving the way for innovation and excellence in the field.',
    image: '/images/team/dharmendra_singh.webp'
  },
  mission: 'Making high-quality technical education accessible to all, empowering individuals to thrive in the digital era regardless of their economic backgrounds.',
  description: 'With over 36 years of Excellence, Shankar Multimedia, an ISO 9001:2015-certified institute based in Mumbai, has been a trusted leader in IT and multimedia animation training. Established in the early 1990s by Dharmendra Kumar Singh, the institute is dedicated to making high-quality technical education accessible to all, empowering individuals to thrive in the digital era regardless of their economic backgrounds.'
};

export const CONTACT_INFO = {
  locations: [
    {
      name: 'Goregaon',
      phone: '+91 9819508524',
      href: 'tel:9819508524',
      address: `501, 503, 504, 505 and 507, 5th Floor, Accord Complex\nOpp. Railway Station and Bus Depot\nGoregaon East, Mumbai - 400 063
      
      603,6th Floor, Accord Classic\nAarey Road Near Railway Station\nGoregaon East, Mumbai - 400 063`,
      mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.686!2d72.8504476!3d19.1652383!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b652db07127b%3A0xf3b080b7f8685b45!2sShankar%20Multimedia%20Goregaon!5e0!3m2!1sen!2sin!4v1234567890',
      googleMapsLink: 'https://maps.app.goo.gl/CmusG4Bn3CLpvCm68'
    },
    {
      name: 'Malad',
      phone: '+91 9223439986', 
      href: 'tel:9223439986',
      address: '501 and 502, 5th Floor, Center Plaza\nShivaji Chowk, Daftary Road\nNear Railway Station, Malad East, Mumbai - 400 097',
      mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.4!2d72.8536065!3d19.1882418!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b742e88680c1%3A0xa24b7c53abee4b69!2sShankar%20Multimedia%20Malad!5e0!3m2!1sen!2sin!4v1234567891',
      googleMapsLink: 'https://maps.app.goo.gl/ifqYs1kLckpHP9Qu9'
    },
    {
      name: 'Mulund',
      phone: '+91 9619177392',
      href: 'tel:9619177392',
      address: '402, 4th Floor, Neptune Uptown, N S Road\nNear Bhau Vada Pav, Near Railway Station\nMulund West, Mumbai - 400 080',
      mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.5!2d72.9557494!3d19.1739317!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b9af02db2c83%3A0xf82e39a8858c9b6b!2sShankar%20Multimedia%20Mulund!5e0!3m2!1sen!2sin!4v1234567892',
      googleMapsLink: 'https://maps.app.goo.gl/FPdhzViQUQArpMZX6'
    },
    {
      name: 'Nalasopara',
      phone: '+91 7021382816',
      href: 'tel:7021382816',
      address: '207, 2nd Floor, MLDC Yashwant Orchid\nOpp. Tulinj Police Station, Central Park Road\nNear Railway Station, Nalasopara East, Mumbai - 401 208',
      mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3763.8!2d72.8190156!3d19.4209828!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x49133f8a8a9a9721%3A0xa50b7762dc524abd!2sShankar%20Multimedia%20Nalasopara!5e0!3m2!1sen!2sin!4v1234567893',
      googleMapsLink: 'https://maps.app.goo.gl/3Qu4KCVJ1YwPDPyK9'
    },
    {
      name: 'Santacruz',
      phone: '+91 7304157986',
      href: 'tel:7304157986',
      address: '804, 8th Floor, Orion West, Station Road\nNear Railway Station, Near Burger King\nSantacruz West, Mumbai - 400 054',
      mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.2!2d72.8393971!3d19.0810422!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c95dd1d12b6b%3A0xae948c5d76d8e95c!2sShankar%20Multimedia%20Santacruz!5e0!3m2!1sen!2sin!4v1234567894',
      googleMapsLink: 'https://maps.app.goo.gl/aKJrfA4JNn4h8Pus8'
    }
  ],
  workingHours: 'Monday To Saturday 8am To 9pm | Sunday 9am To 2pm',
  website: 'http://www.shankarmultimedia.com'
};

export const NAVIGATION_MENU = [
  { name: 'HOME', path: '/', active: true },
  { name: 'STUDENTS WORK', path: '/students-work' },
  { name: 'ABOUT US', path: '/about' },
  { name: 'PLACEMENTS', path: '/placements' },
  { name: 'CONTACT US', path: '/contact' }
];

export const COURSES_DATA = [
  {
    id: 'graphic-design-ui-ux',
    name: 'Graphic Design and UI/UX',
    title: 'Diploma in Advanced Graphic Design & UI/UX Design with AI Integration',
    description: 'Master visual communication and user experience design with industry-standard tools and techniques.',
    image: '/images/courses/gra1.webp',
    banner: '/images/courses/gra1.webp',
    background: '/images/courses/gra1.webp',
    tools: ['Adobe Photoshop', 'CorelDRAW', 'Adobe Illustrator', 'Adobe InDesign', 'Adobe XD', 'Figma', 'Canva','Artificial Intelligence (AI) Tools & Generative AI'],
    category: 'Design'
  },
  {
    id: 'graphic-design-motion-vfx',
    name: 'Complete Graphic Design and VFX',
    title: 'Diploma in Advanced Graphic Design, UI/UX, Motion Graphics, Video Editing and VFX with AI Integration',
    description: 'Comprehensive course covering all aspects of digital design, motion graphics, and video production.',
    image: '/images/courses/gra1.webp',
    banner: '/images/courses/gra1.webp',
    background: '/images/courses/gra1.webp',
    tools: ['Adobe Photoshop', 'CorelDRAW', 'Adobe Illustrator', 'Adobe InDesign', 'Adobe XD', 'Figma', 'Canva', 'Adobe After Effects', 'Adobe Premiere Pro', 'Adobe Media Encoder','Artificial Intelligence (AI) Tools & Generative AI'],
    category: 'Design'
  },
  {
    id: '3d-animation',
    name: '3D Animation',
    title: 'Diploma in Advanced 3D Modeling & Animation with AI Integration',
    description: 'Create stunning 3D animations and models for games, films, and architectural visualization.',
    image: '/images/courses/3d.webp',
    banner: '/images/courses/3d.webp',
    background: '/images/3D_bg.webp',
    tools: ['Adobe Photoshop', 'CorelDRAW', '3Ds Max', 'V-Ray Rendering', 'Corona Render', 'Autocad', 'SketchUp','Artificial Intelligence (AI) Tools & Generative AI'],
    category: 'Animation'
  },
  {
    id: '3d-animation-vfx',
    name: '3D Animation and VFX',
    title: 'Diploma in Advanced 3D Modeling, Animation & VFX with AI Integration ',
    description: 'Advanced 3D course with visual effects for film and television industry.',
    image: '/images/courses/3d.webp',
    banner: '/images/courses/3d.webp',
    background: '/images/3D_bg.webp',
    tools: ['Adobe Photoshop', 'CorelDRAW', '3Ds Max', 'V-Ray Rendering', 'Corona Render', 'Autocad', 'SketchUp', 'Adobe After Effects', 'Adobe Premiere Pro', 'Adobe Media Encoder','Artificial Intelligence (AI) Tools & Generative AI'],
    category: 'Animation'
  },
  {
    id: 'web-design-development',
    name: 'Web Design and Development',
    title: 'Diploma in Advanced Web Design, Development & UI/UX with AI Integration',
    description: 'Build modern, responsive websites and web applications with latest technologies.',
    image: '/images/courses/web1.webp',
    banner: '/images/courses/web1.webp',
    background: '/images/courses/DW_bg.webp',
    tools: ['Adobe Photoshop','Adobe XD','Figma','Adobe Dreamweaver','HTML5','CSS3 / SCSS','JavaScript / jQuery','React.js','Bootstrap 4 and 5','WordPress','Notepad++','Sublime Text','Visual Studio Code','Brackets','Artificial Intelligence (AI) Tools & Generative AI'],
    category: 'Development'
  },
  {
    id: 'digital-marketing',
    name: 'Digital Marketing',
    title: 'Diploma in Advanced Digital Marketing with AI Integration & Automation',
    description:'Become a job-ready digital marketer with hands-on training in SEO, Ads, Social Media, Analytics, AI tools and Marketing Automation with live campaigns.',
    image: '/images/courses/digital1.webp',
    banner: '/images/courses/digital1.webp',
    background: '/images/courses/DM_bg.webp',
    tools: ['WordPress','Yoast SEO','Rank Math','Canva','Google Trends','Google Analytics 4','Google Search Console','Google Keyword Planner','Google Ads','Google Business Manager','Meta Ads Manager','Instagram','Facebook','YouTube','LinkedIn','Mailchimp','ZOHO Campaigns','Buffer','Zapier','Artificial Intelligence (AI) Tools & Generative AI'],
    category: 'Marketing'
  },
  {
    id: 'multimedia-animation-vfx',
    name: 'Multimedia Animation and VFX',
    title: 'Diploma in Advanced Multimedia, Animation & VFX with AI Integration',
    description: 'Comprehensive multimedia course covering all aspects of animation and visual effects.',
    image: '/images/courses/p_a.webp',
    banner: '/images/courses/p_a1.webp',
    background: '/images/courses/3D_bg.webp',
    tools: ['Adobe Photoshop', 'CorelDRAW', 'Adobe Illustrator', 'Adobe InDesign', 'Adobe XD', 'Figma', 'Canva', 'Adobe After Effects', 'Adobe Premiere Pro', 'Adobe Media Encoder', '3Ds Max', 'V-Ray Rendering', 'Corona Render', 'Autocad', 'SketchUp','Artificial Intelligence (AI) Tools & Generative AI'],
    category: 'Animation'
  }
];

export const FEATURES = [
  'Job Placement Support',
  'ISO 9001:2015 Certified Institute', 
  '36+ years of Excellence',
  'Industry Expert Faculty',
  'Hands-on Project Training',
  'Multiple Branch Locations',
  'Flexible Timing Options',
  'Advanced Diploma Programs'
];


export const HERO_CONTENT = {
  title: 'Shankar Multimedia',
  subtitle: '36 years of Excellence',
  description: 'ISO 9001:2015 Certified Institute | Job Placement Support | Industry-Driven Sessions | Expert-Led Sessions | Global Alumni Network',
  
  banners: [
    '/images/courses/online.webp',
    '/images/courses/gra1.webp',
    '/images/courses/web1.webp',
    '/images/courses/3d1.webp',
    '/images/courses/vfx.webp'
  ],
  
};

export const ABOUT_CONTENT = {
  subtitle: '36+ years of Excellence in IT and Multimedia Animation Training',
  description: `Since 1990, Shankar Multimedia has been a trusted name in IT, multimedia animation, graphic design, web development, and digital education in Mumbai. As an ISO 9001:2015-certified and government-recognized institute, we have built a strong reputation for delivering industry-backed training that prepares students for meaningful careers in the creative and technology sectors. Founded by Mr. Dharmendra Singh, the institute was established with a clear mission to make quality technical and creative education accessible to aspiring learners from all backgrounds. Over the years, Shankar Multimedia has empowered thousands of students with practical knowledge, professional discipline, and career-focused learning that reflects the changing demands of the digital world.

Our programs are designed to bridge the gap between classroom learning and real industry expectations through live projects, guided assignments, portfolio development, expert-led workshops, and personalized mentorship. With modern infrastructure, experienced faculty, and a continuously updated curriculum, we ensure that every student receives practical, relevant, and future-ready training. Our advanced diploma programs are structured to help learners develop strong capabilities in multimedia animation, graphic design, motion graphics, VFX, web development, UI/UX design, and digital marketing, while building the confidence needed to succeed in today’s competitive job market.

Under his guidance, the institute has grown steadily while remaining focused on its core values of accessibility, excellence, and opportunity. He continues to lead with purpose, inspiring students and faculty alike through a strong vision for career-oriented education and social upliftment through skill development.`,
  vision: 'To be recognized as one of the most trusted and leading institutes in multimedia and IT education by empowering students with advanced, industry-relevant skills and preparing them for successful placement in the creative and digital industries.',
  mission: 'To make high-quality technical and creative education accessible and affordable for all, enabling individuals from every background to develop strong professional skills and build successful careers in the evolving digital era.'
};

export const MANAGEMENT_TEAM = [
  {
    id: 1,
    name: 'Mr. Dharmendra Singh',
    position: 'Founder / Chairman',
    image: '/images/team/dharmendra_singh.webp',
    description: `Mr. Dharmendra Singh is the visionary founder and driving force behind Shankar Multimedia. With a deep commitment to transforming creative education in India, he established the institute with the belief that quality learning should be accessible to every aspiring student, regardless of background. His leadership has shaped Shankar Multimedia into a respected institution known for academic integrity, practical training, and long-term student success.

  Under his guidance, the institute has grown steadily while remaining focused on its core values of accessibility, excellence, and opportunity. He continues to lead with purpose, inspiring students and faculty alike through a strong vision for career-oriented education and social upliftment through skill development.`
  },
  {
    id: 2,
    name: 'Mr. Deepak Singh',
    position: 'Chief Operating Officer',
    image: '/images/team/deepak_singh.webp',
    description: `Mr. Deepak Singh is one of the founding pillars of Shankar Multimedia and plays a key role in its academic, technical, and placement operations. With over 26 years of professional experience in graphics, 3D, web development, and digital media, he brings deep industry insight and operational strength to the institute. His expertise ensures that the training programs remain aligned with current industry standards and employer expectations.

He has been instrumental in building strong relationships with companies and creative professionals, helping create real career opportunities for students. Known for his disciplined approach, practical mindset, and student-focused attitude, he contributes significantly to the institute’s reputation as a reliable and career-driven training center.`
  },
  {
    id: 3,
    name: 'Mr. Saurabh Singh',
    position: 'HOD - Operations',
    image: '/images/team/saurabh_singh.webp',
    description: `Mr. Saurabh Singh brings more than 24 years of experience in media, operations, and institutional management. At Shankar Multimedia, he leads operational excellence while ensuring that students receive the support, structure, and mentorship they need to grow both professionally and personally. His expertise lies in helping learners understand workplace expectations, develop communication skills, and build the confidence required to succeed in competitive environments.

He plays an important role in shaping the student experience by fostering discipline, guidance, and career readiness. His leadership supports the institute’s commitment to producing well-trained, responsible, and industry-ready professionals.`
  },
  {
    id: 4,
    name: 'Mr. Anurag Singh',
    position: 'Center Director',
    image: '/images/team/anurag_singh.webp',
    description: `Mr. Anurag Singh serves as the Center Director and is widely respected for his approachable leadership and student-first attitude. With over 22 years of experience in the multimedia industry, he provides students with practical guidance, encouragement, and the mentorship required to overcome challenges and stay focused on their goals. His presence strengthens the institute’s learning environment by creating a culture of support, motivation, and continuous improvement.

He is deeply involved in day-to-day training operations and student development, ensuring that each learner receives personalized attention and the right direction throughout their academic journey. His commitment to excellence and positive leadership plays a vital role in helping students move confidently toward successful careers.`
  }
];

export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/people/Shankar-Multimedia/pfbid0KrYer6RVgUrWPWEZDcAD9XN7UsdfNHavcq53Q6BVuvMHU62vj5QwKvog6QeiHJKol/?rdid=h8Wzjw4Rc1WQG8qI&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1Aq8BsLAL2%2F',
  instagram: 'https://www.instagram.com/shankarmultimedia/?hl=en',
  youtube: 'https://www.youtube.com/@ShankarMultimediaMumbai',
  whatsapp: 'https://wa.me/919819508524?text=Hi',
  threads: 'https://www.threads.com/@shankarmultimedia'
};

export const PLACEMENT_COMPANIES = [
  { id: 1, name: 'Yash Raj Films Studio', logo: '/images/company/1.webp', alt: 'Yash Raj Films Studio' },
  { id: 2, name: 'Red Chillies Entertainment', logo: '/images/company/2.webp', alt: 'Red Chillies Entertainment' },
  { id: 3, name: 'IPL', logo: '/images/company/3.webp', alt: 'IPL' },
  { id: 4, name: 'Jio', logo: '/images/company/4.webp', alt: 'Jio' },
  { id: 5, name: 'Nykaa', logo: '/images/company/5.webp', alt: 'Nykaa' },
  { id: 6, name: 'Cimpress', logo: '/images/company/6.webp', alt: 'Cimpress' },
  { id: 7, name: 'L&T Infotech', logo: '/images/company/7.webp', alt: 'L&T Infotech' },
  { id: 8, name: 'Wipro', logo: '/images/company/8.webp', alt: 'Wipro' },
  { id: 9, name: 'Drishyam Films', logo: '/images/company/9.webp', alt: 'Drishyam Films' },
  { id: 10, name: 'Zee', logo: '/images/company/10.webp', alt: 'Zee' },
  { id: 11, name: 'Hungama', logo: '/images/company/11.webp', alt: 'Hungama' },
  { id: 12, name: 'Dream 11', logo: '/images/company/12.webp', alt: 'Dream 11' },
  { id: 13, name: 'Accenture', logo: '/images/company/13.webp', alt: 'Accenture' },
  { id: 14, name: 'Patni', logo: '/images/company/14.webp', alt: 'Patni' },
  { id: 15, name: 'Lionbridge', logo: '/images/company/15.webp', alt: 'Lionbridge' },
  { id: 16, name: 'Publicis', logo: '/images/company/16.webp', alt: 'Publicis'} ,
  { id: 17, name: 'Vistaprint', logo: '/images/company/17.webp', alt: 'Vistaprint' },
  { id: 18, name: 'TATA Consultancy Services', logo: '/images/company/18.webp', alt: 'TATA Consultancy Services' },
  { id: 19, name: 'DNEG', logo: '/images/company/19.webp', alt: 'DNEG' },
  { id: 20, name: 'Johnson-Johnson', logo: '/images/company/20.webp', alt: 'Johnson-Johnson' },
  { id: 21, name: 'Ogilvy', logo: '/images/company/21.webp', alt: 'Ogilvy' },
  { id: 22, name: 'Saint-Gobain', logo: '/images/company/22.webp', alt: 'Saint-Gobain' },
  { id: 23, name: 'TATA ELXSI', logo: '/images/company/23.webp', alt: 'TATA ELXSI' },
  { id: 24, name: 'RenderCAD', logo: '/images/company/24.webp', alt: 'RenderCAD' },
  { id: 25, name: 'Prime Focus Technologies', logo: '/images/company/25.webp', alt: 'Prime Focus Technologies' },
  { id: 26, name: 'Cognizant', logo: '/images/company/26.webp', alt: 'Cognizant' },
  { id: 27, name: 'WITS Interactive', logo: '/images/company/27.webp', alt: 'WITS Interactive' },
  { id: 28, name: 'Directi', logo: '/images/company/28.webp', alt: 'Directi' },
  { id: 29, name: 'Reliance Digital', logo: '/images/company/29.webp', alt: 'Reliance Digital' },
  { id: 30, name: 'SONY', logo: '/images/company/30.webp', alt: 'SONY' },
  { id: 31, name: 'Indusind Nippon Life Insurance', logo: '/images/company/31.webp', alt: 'Indusind Nippon Life Insurance' },
  { id: 32, name: 'DMart', logo: '/images/company/32.webp', alt: 'DMart' },
  { id: 33, name: 'KnowledgeWorks Global Ltd.', logo: '/images/company/33.webp', alt: 'KnowledgeWorks Global Ltd.' },
  { id: 34, name: 'Shemaroome', logo: '/images/company/34.webp', alt: 'Shemaroome' },
  { id: 35, name: 'Denstu', logo: '/images/company/35.webp', alt: 'Denstu' },
  { id: 36, name: '& many more...', logo: '', alt: '& many more...' }
];

const CONTENT_DATA = {
  COMPANY_INFO,
  CONTACT_INFO,
  NAVIGATION_MENU,
  COURSES_DATA,
  FEATURES,
  HERO_CONTENT,
  ABOUT_CONTENT
};

export default CONTENT_DATA;
